(function () {
  "use strict";

  var r = {
    175: function _(r, o, e) {
      var _t,
          n = this && this.__extends || (_t = function t(r, o) {
        return _t = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (r, o) {
          r.__proto__ = o;
        } || function (r, o) {
          for (var e in o) {
            Object.prototype.hasOwnProperty.call(o, e) && (r[e] = o[e]);
          }
        }, _t(r, o);
      }, function (r, o) {
        if ("function" != typeof o && null !== o) throw new TypeError("Class extends value " + String(o) + " is not a constructor or null");

        function e() {
          this.constructor = r;
        }

        _t(r, o), r.prototype = null === o ? Object.create(o) : (e.prototype = o.prototype, new e());
      }),
          i = this && this.__importDefault || function (r) {
        return r && r.__esModule ? r : {
          default: r
        };
      };

      Object.defineProperty(o, "__esModule", {
        value: !0
      }), o.InsufficientBalanceError = o.InvalidExpirationError = o.InvalidAddressError = o.InvalidSecretError = o.NodeError = o.WalletError = o.InvalidDestinationAddressError = o.BlockNotFoundError = o.TxFailedError = o.TxNotFoundError = o.PendingTxError = o.InvalidProviderResponseError = o.UnimplementedMethodError = o.UnsupportedMethodError = o.NoProviderError = o.DuplicateProviderError = o.InvalidProviderError = o.ProviderNotFoundError = o.StandardError = void 0;
      var d = i(e(959));

      function a(r) {
        var o = function (r) {
          function o() {
            return null !== r && r.apply(this, arguments) || this;
          }

          return n(o, r), o;
        }(d.default);

        return o.prototype.name = r, o;
      }

      o.StandardError = a("StandardError"), o.ProviderNotFoundError = a("ProviderNotFoundError"), o.InvalidProviderError = a("InvalidProviderError"), o.DuplicateProviderError = a("DuplicateProviderError"), o.NoProviderError = a("NoProviderError"), o.UnsupportedMethodError = a("UnsupportedMethodError"), o.UnimplementedMethodError = a("UnimplementedMethodError"), o.InvalidProviderResponseError = a("InvalidProviderResponseError"), o.PendingTxError = a("PendingTxError"), o.TxNotFoundError = a("TxNotFoundError"), o.TxFailedError = a("TxFailedError"), o.BlockNotFoundError = a("BlockNotFoundError"), o.InvalidDestinationAddressError = a("InvalidDestinationAddressError"), o.WalletError = a("WalletError"), o.NodeError = a("NodeError"), o.InvalidSecretError = a("InvalidSecretError"), o.InvalidAddressError = a("InvalidAddressError"), o.InvalidExpirationError = a("InvalidExpirationError"), o.InsufficientBalanceError = a("InsufficientBalanceError");
    },
    959: function _(r) {
      r.exports = require("standard-error");
    }
  },
      o = {},
      e = function e(t) {
    var n = o[t];
    if (void 0 !== n) return n.exports;
    var i = o[t] = {
      exports: {}
    };
    return r[t].call(i.exports, i, i.exports, e), i.exports;
  }(175);

  module.exports = e;
})();